






































import Component from 'vue-class-component'
import Vue from 'vue'
import { OrganisationLiteResponse } from '@/api/generated'
import { OrganisationsModule } from '@/business/organisation/store/organisations-module'
import { Injector } from '@/config/dependency-injection'

@Component
export default class OrganisationSettings extends Vue {
  private organisationsModule: OrganisationsModule = Injector.get(OrganisationsModule)

  get organisation(): OrganisationLiteResponse {
    return this.organisationsModule.organisationViewModel.organisation
  }
}
